import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-gift_2",
  "use": "icon-gift_2-usage",
  "viewBox": "0 0 15 18",
  "content": "<symbol viewBox=\"0 0 15 18\" id=\"icon-gift_2\">\n  <path class=\"cls-1\" d=\"M173,857h-7v-4h-1v4h-7v-4h5l-3-3h2v-2l3,3h1l3-3v2h2l-3,3h5v4Zm-8,9h-6v-8h6v8Zm7,0h-6v-8h6v8Z\" transform=\"translate(-158 -848)\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol